<template>
  <div>
    <div class="container-fluid" style="padding: 0">
      <div class="row">
        <div class="col-12 col-md-3 max-height" style="padding: 0">
          <md-content class="md-scrollbar">
            <div v-if="canEquipamentoCriar()" style="text-align: center">
              <md-button
                :to="{
                  name: 'EquipamentoCampoTemplate',
                  params: { localId: $route.params.localId },
                }"
                class="md-primary"
              >
                Adicionar Equipamento
              </md-button>
            </div>

            <div id="custom-scroll" class="custom-col">
              <md-card
                v-for="equipamento in equipamentos"
                :id="`equipamento-${equipamento.id}`"
                :key="equipamento.id"
                class="custom-col-card"
                :class="
                  currentEquipamento === equipamento.id
                    ? 'md-elevation-10 selected'
                    : ''
                "
                md-with-hover
                style="flex-grow: 1; margin-top: 2vh"
                @click.native="selectEquipamento(equipamento.id)"
              >
                <md-card-header>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-80 md-title">
                      {{ equipamento.nome }}
                    </div>
                    <div class="md-layout-item">
                      <md-menu
                        md-size="small"
                        :md-offset-x="127"
                        :md-offset-y="-36"
                      >
                        <md-button
                          class="md-icon-button"
                          md-menu-trigger
                          @click.stop=""
                        >
                          <md-icon>list</md-icon>
                        </md-button>
                        <md-menu-content>
                          <md-menu-item
                            v-if="isAdmin()"
                            @click="() => handleAbrirDadoAvulso(equipamento.id)"
                          >
                            Adicionar valor avulso
                          </md-menu-item>
                          <md-menu-item
                            @click="() => handleDownloadCsv(equipamento.id)"
                          >
                            Baixar dados CSV
                          </md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </div>
                  </div>

                  <span class="md-list-item-text">{{
                    equipamento.descricao
                  }}</span>
                </md-card-header>

                <md-card-content style="padding-bottom: 0">
                  <md-list class="md-dense">
                    <!--                                        <md-list-item>-->
                    <!--                                            <md-icon>description</md-icon>-->
                    <!--                                            <span class="md-list-item-text">{{ equipamento.descricao }}</span>-->
                    <!--                                        </md-list-item>-->

                    <md-list-item>
                      <md-icon>location_on</md-icon>
                      <span class="md-list-item-text"
                        >{{ equipamento.latitude }},
                        {{ equipamento.longitude }}</span
                      >
                    </md-list-item>
                  </md-list>
                  <md-card-actions>
                    <md-dialog-confirm
                      :md-active.sync="active"
                      md-title="Tem certeza?"
                      md-content="Deletar um equipamento é uma ação irreversível. Após concluída os dados do equipamento não poderão ser recuperados"
                      md-confirm-text="deletar"
                      md-cancel-text="cancelar"
                      @md-confirm="excluir(equipamentoIdParaDeletar)"
                    />
                    <md-button
                      v-if="isAdmin()"
                      class="md-accent"
                      @click="() => abrirExcluirEquipamento(equipamento.id)"
                    >
                      Excluir
                    </md-button>
                    <md-button
                      v-if="canAcessarPainelEquipamento()"
                      @click.stop="() => editar(equipamento)"
                    >
                      Editar
                    </md-button>
                    <md-button
                      v-if="canSendAction()"
                      class="md-raised md-primary"
                      @click.stop="() => toggleTab(equipamento.id)"
                    >
                      Ações
                    </md-button>
                  </md-card-actions>
                </md-card-content>
              </md-card>
            </div>
          </md-content>
        </div>
        <div class="col-12 col-md-9 max-height">
          <div class="row">
            <div class="col-12 col-md-2">
              <md-field style="border-bottom: none">
                <label for="sensor-filtro">Filtro rápido</label>
                <md-select
                  id="sensor-filtro"
                  v-model="filtro.offset"
                  name="sensor-filtro"
                  @md-selected="fetchSensores"
                >
                  <md-option :value="milliseconds(30, 'min')">
                    30 min
                  </md-option>
                  <md-option :value="milliseconds(1, 'hora')">
                    1 hora
                  </md-option>
                  <md-option :value="milliseconds(2, 'hora')">
                    2 horas
                  </md-option>
                  <md-option :value="milliseconds(4, 'hora')">
                    4 horas
                  </md-option>
                  <md-option :value="milliseconds(8, 'hora')">
                    8 horas
                  </md-option>
                  <md-option :value="milliseconds(16, 'hora')">
                    16 horas
                  </md-option>
                  <md-option :value="milliseconds(24, 'hora')">
                    24 horas
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="col-12 col-md-3">
              <md-datepicker
                v-model="filtro.dataInicio"
                :md-close-on-blur="false"
              >
                <label>Data Inicio</label>
              </md-datepicker>
            </div>
            <div class="col-12 col-md-3">
              <md-datepicker
                v-model="filtro.dataFinal"
                :md-close-on-blur="false"
              >
                <label>Data Final</label>
              </md-datepicker>
            </div>
            <div class="col-6 col-md-2">
              <md-button class="md-primary" @click="limparFiltro">
                Tirar Filtro
              </md-button>
            </div>

            <div class="col-6 col-md-2">
              <md-button class="md-primary" @click="fetchSensores">
                Buscar
              </md-button>
            </div>
          </div>
          <md-content
            v-if="sensores"
            :class="fetchingSensores === true ? 'loading' : ''"
          >
            <div class="row">
              <div
                v-for="[equipamento_id, tipo, data] in sensores"
                :key="equipamento_id + tipo + 'graphic'"
                class="col-lg-6 col-md-12 p-0"
              >
                <graphic-area
                  :sensores="data"
                  :tipo="tipo"
                  :max-value.sync="filtro.dataFinal"
                  :min-value.sync="filtro.dataInicio"
                  :range="filtro.range || filtro.offset"
                  :show-marker="filtro.range <= 28800000"
                />
              </div>
              <br />
              <br /><br />
            </div>
          </md-content>
          <md-content v-if="fetchingSensores">
            <div class="absolute">
              <div>
                <md-progress-spinner
                  :md-diameter="150"
                  :md-stroke="10"
                  md-mode="indeterminate"
                />
              </div>
            </div>
          </md-content>
          <div v-if="!sensores && !fetchingSensores">
            <md-empty-state
              md-rounded
              md-icon="timeline"
              md-label="Equipamento não selecionado"
              md-description="Selecione algum equipamento para ter mais detalhes sobre os sensores"
            />
          </div>
        </div>
      </div>
    </div>
    <slider-right id="slideLeft" ref="slider">
      <EquipamentoAcoes ref="acoes" />
    </slider-right>

    <md-dialog :md-active.sync="dadoAvulso.isActive" :md-fullscreen="true">
      <md-dialog-content>
        <EquipamentoSelecionarSensor
          v-if="dadoAvulso.isActive"
          :equipamento-id="dadoAvulso.equipamentoId"
          @change="onChangeSensor"
        />
      </md-dialog-content>
    </md-dialog>

    <md-dialog :md-active.sync="downloadCsv.isActive" :md-fullscreen="true">
      <md-dialog-content>
        <EquipamentoDownloadCsv
          v-if="downloadCsv.isActive"
          :equipamento-id="downloadCsv.equipamentoId"
          @close="closeDownloadCsv"
        />
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import EquipamentoAcoes from '../../components/equipamento/EquipamentoAcoes'
import EquipamentoDownloadCsv from '../../components/equipamento/EquipamentoDownloadCsv'
import EquipamentoSelecionarSensor from '../../components/equipamento/EquipamentoSelecionarSensor'
import GraphicArea from '../../components/GraphicArea'
import SliderRight from '../../components/SliderLeft'
import auth from '../../utils/auth'
import http from '../../utils/http'

export default {
  name: 'EquipamentoDetalhe',
  components: {
    EquipamentoDownloadCsv,
    EquipamentoSelecionarSensor,
    EquipamentoAcoes,
    SliderRight,
    GraphicArea,
  },
  data() {
    return {
      tiposSensores: {},
      equipamentos: [],
      sensores: null,
      fetchingSensores: false,
      currentEquipamento: null,
      localId: null,
      editanto: false,
      criando: false,
      filtro: {
        // Ultimas duas horas
        offset: 1000 * 60 * 60 * 2,
        dataInicio: null,
        dataFinal: null,
        range: null,
        maxValue: new Date().getTime(),
      },
      dadoAvulso: {
        isActive: false,
        equipamentoId: null,
      },
      downloadCsv: {
        isActive: false,
        equipamentoId: null,
      },
      openTab: false,
      active: false,
      equipamentoIdParaDeletar: null,
    }
  },
  beforeMount() {
    this.localId = this.$route.params.localId

    if (this.$route.query.e) {
      this.currentEquipamento = this.$route.query.e
    }
  },
  mounted() {
    this.loadTiposSensores().then(() => {
      this.initEquipamentos(this.localId)
    })
  },
  created() {},
  methods: {
    canEquipamentoCriar: auth.canEquipamentoCriar,
    canEquipamentoEditar: auth.canEquipamentoEditar,
    canAcessarPainelEquipamento() {
      return (
        auth.canEquipamentoEditar() || auth.canCmdAuto() || auth.canCalibracao()
      )
    },
    loadTiposSensores() {
      return http.get('tiposSensores').then((response) => {
        this.tiposSensores = response.tiposSensores.reduce((acc, e) => {
          acc[e.tipo] = e
          return acc
        }, {})
      })
    },
    handleAbrirDadoAvulso(id) {
      this.dadoAvulso.isActive = true
      this.dadoAvulso.equipamentoId = id
    },
    handleDownloadCsv(id) {
      this.downloadCsv.isActive = true
      this.downloadCsv.equipamentoId = id
    },
    closeDownloadCsv() {
      this.downloadCsv.isActive = false
      this.downloadCsv.equipamentoId = null
    },
    isAdmin() {
      return auth.isAdmin()
    },
    canSendAction() {
      return auth.canSendAction()
    },
    editar(equipamento) {
      this.$router.push({
        name: 'EquipamentoCampoEditar',
        params: { equipamentoId: equipamento.id },
      })
    },
    abrirExcluirEquipamento(id) {
      this.active = true
      this.equipamentoIdParaDeletar = id
    },
    async excluir(equipamentoId) {
      this.fetchingSensores = true
      this.equipamentoIdParaDeletar = null
      this.active = false
      await http.delete('equipamento', equipamentoId)
      this.fetchingSensores = false
      this.currentEquipamento = null
      await this.initEquipamentos(this.localId)
    },
    onChangeSensor() {
      this.selectEquipamento(this.currentEquipamento, true)
    },
    openCreate() {
      const editando = this.editanto

      this.editarId = null
      this.editanto = false
      this.criando = true
      this.equipamento = null

      this.$refs.forms.setData()

      this.toggleTwoWithAnimation(editando)
    },
    toggleTab(equipamentoId) {
      // Significa que está aberto
      // Para executar animacao
      // if (this.openTab) {
      //     this.$refs.slider.toogleTab();
      //     setTimeout(() => {
      //         this.$refs.slider.toogleTab();
      //     }, 300);
      // } else {
      //     this.$refs.slider.toogleTab();
      //     this.openTab = true;
      // }

      this.$refs.slider.toogleTab()

      this.$refs.acoes.searchAcoes(equipamentoId)
    },
    closeTab() {
      this.editanto = false
      this.criando = false
      this.openTab = false
      this.$refs.slider.close()
    },
    async initEquipamentos(localId) {
      const response = await http.get(`local/${localId}`)
      this.equipamentos = response.local.equipamentos

      if (response.local.equipamentos.length >= 1) {
        if (this.currentEquipamento === null) {
          await this.selectEquipamento(response.local.equipamentos[0].id)
        } else {
          this.$nextTick(() => {
            this.scrollToEquipamento(this.currentEquipamento)
          })
          await this.selectEquipamento(this.currentEquipamento, true)
        }
      }
    },
    scrollToEquipamento(equipamentoId) {
      const el = document.getElementById(`equipamento-${equipamentoId}`)
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      })
    },
    async selectEquipamento(equipamentoId, permitSameId = false) {
      if (equipamentoId === this.currentEquipamento && !permitSameId) {
        return
      }

      const url = new URL(window.location)
      if (url.searchParams.get('e') !== equipamentoId) {
        url.searchParams.set('e', equipamentoId)
        window.history.pushState(null, '', url.toString())
      }

      this.fetchingSensores = true
      this.currentEquipamento = equipamentoId

      await this.fetchSensores()
    },
    limparFiltro() {
      this.filtro = {
        offset: 0,
        dataInicio: null,
        dataFinal: null,
        range: 1000 * 60 * 60 * 2,
        maxValue: new Date().getTime(),
      }

      this.fetchSensores()
    },
    async changeEquipamento() {
      await this.initEquipamentos(this.localId)

      this.closeTab()

      await this.selectEquipamento(this.currentEquipamento)
    },
    milliseconds(n, unidade) {
      switch (unidade) {
        case 'min':
          return 1000 * 60 * n
        case 'hora':
          return 1000 * 60 * 60 * n
        default:
          return 0
      }
    },
    async fetchSensores() {
      this.fetchingSensores = true

      let url = `equipamento/${this.currentEquipamento}/sensores?`

      if (this.filtro.dataInicio && this.filtro.dataFinal) {
        const dataInicioISO = new Date(this.filtro.dataInicio).toISOString()

        const finalDate = new Date(this.filtro.dataFinal)
        finalDate.setHours(23, 59, 59, 999)
        this.filtro.maxValue = finalDate.getTime()

        const now = new Date()

        if (
          finalDate.getDay() === now.getDay() &&
          finalDate.getMonth() === now.getMonth() &&
          finalDate.getFullYear() === now.getFullYear()
        ) {
          this.filtro.range =
            new Date() - new Date(this.filtro.dataInicio).getTime()
        } else {
          this.filtro.range =
            this.filtro.maxValue - new Date(this.filtro.dataInicio).getTime()
        }

        finalDate.setHours(0)
        const dataFinalISO = finalDate.toISOString()

        url += `dataInicio=${dataInicioISO}&dataFinal=${dataFinalISO}`
      } else if (this.filtro.offset) {
        this.filtro.range = this.filtro.offset
        url += `periodo=${new Date(
          new Date().getTime() - this.filtro.offset
        ).toISOString()}`
      }

      const response = await http.get(url)
      if (!response) {
        return
      }

      let tipos = Object.keys(response.sensores)

      tipos = tipos.sort(
        (a, b) =>
          (this.tiposSensores[a]?.prioridade ?? 0) -
          (this.tiposSensores[b]?.prioridade ?? 0)
      )

      // Ordena os tipos de sensores
      this.sensores = tipos.map((tipo) => [
        new Date().valueOf(),
        tipo,
        response.sensores[tipo],
      ])
      this.fetchingSensores = false
    },
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 960px) and (min-width: 601px) {
  .custom-row,
  .custom-col {
    height: 94vh !important;
  }
}

.max-height {
  @media only screen and (min-width: 960px) {
    max-height: 90vh;
    height: 90vh;
    overflow: auto;
    overflow-x: hidden;
  }
}

.custom-row {
  display: flex;
  flex-direction: row;
}

.custom-col-2 {
  flex: 0.2 0 min-content;
  overflow: auto;
}

.custom-col-max {
  flex: 1 0 auto;
  overflow: auto;
}

.custom-col-card {
  @media only screen and (max-width: 960px) {
    display: inline-block;
  }
}

.custom-col {
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 960px) {
    max-width: 100vw;
    // reset display
    display: inline-block;
    overflow-x: scroll;
    white-space: nowrap;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }
}

.grafico-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(auto-fill, 50%);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}

.md-empty-state {
  margin-top: 20vh;
}

.selected {
  border: #7e53a2 solid 2px;
}

.loading {
  filter: brightness(90%);
}

.absolute {
  position: absolute;
  right: 50%;
  top: 50%;
}
</style>
